import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContextService } from '@perval/shared';
import { EmailService } from '../../../authentification/services/email/email.service';
import {
  PervalValidators,
  Utilisateur,
  UtilisateurService,
} from '../../../shared';
import { ErrorsService } from '../../../shared/errors/errors.service';
import { BehaviorService } from '../../../shared/services/behavior/behavior.service';

@Component({
  selector: 'app-add-collab',
  templateUrl: './add-collab.component.html',
  styleUrls: ['./add-collab.component.scss'],
})
export class AddCollabComponent {
  loading = false;
  showSuccessMsg = false;
  showErrorMsg = false;
  errorMessage = '';

  addCollabForm = new FormGroup({
    prenom: new FormControl('', [Validators.required]),
    nom: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, PervalValidators.email]),
  });

  private utilisateur!: Utilisateur;

  constructor(
    private readonly utilisateurService: UtilisateurService,
    private readonly errorsService: ErrorsService,
    private readonly behaviorService: BehaviorService,
    private readonly emailService: EmailService,
    private readonly contextService: ContextService,
  ) {}

  public async createCollab() {
    this.loading = true;
    this.showSuccessMsg = false;
    this.showErrorMsg = false;

    this.utilisateur = {
      ...this.utilisateur,
      prenom: this.addCollabForm.value.prenom!,
      nom: this.addCollabForm.value.nom!,
      email: this.addCollabForm.value.email!,
    };

    try {
      await this.utilisateurService.addUtilisateur(this.utilisateur);

      const username = this.contextService.getContext()?.username;

      if (username === undefined) {
        throw new Error("Impossible de récupérer le login de l'utilisateur.");
      }

      const gestionnaire =
        await this.utilisateurService.getUtilisateurByLogin(username);

      if (gestionnaire?.email && gestionnaire.email !== '') {
        await this.emailService.sendEmailValidationGestionnaire(
          this.utilisateur,
          gestionnaire,
        );
      }

      this.showSuccessMsg = true;
      this.loading = false;
      this.addCollabForm.setValue({
        prenom: '',
        nom: '',
        email: '',
      });
      this.addCollabForm.markAsPristine();
      this.addCollabForm.markAsUntouched();
      this.addCollabForm.updateValueAndValidity();
      this.behaviorService.scrollToTheTop();
      // TODO : gérer les erreurs correctement dans NPER-812
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      this.errorMessage = this.errorsService.getError(
        err?.error?.errors[0]?.message ?? err?.message,
      );
      this.showErrorMsg = true;
      this.behaviorService.scrollToTheTop();
      this.loading = false;
    }
  }
}
